"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAvatarIcon = exports.AdditionalPlayerIcon = exports.Avatar = exports.DEFAULT_AVATAR_SIZE = void 0;
const react_1 = __importDefault(require("react"));
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const avatar_image_1 = require("./avatar_image");
const react_native_1 = require("react-native");
exports.DEFAULT_AVATAR_SIZE = 30;
function Avatar({ name, color, border, size = exports.DEFAULT_AVATAR_SIZE, style }) {
    return (react_1.default.createElement(exports.BaseAvatarIcon, { color: color, border: border, size: size, style: style },
        react_1.default.createElement(avatar_image_1.AvatarImage, { width: "75%", height: "75%", name: name })));
}
exports.Avatar = Avatar;
const AdditionalPlayerIcon = ({ num, border, size = exports.DEFAULT_AVATAR_SIZE, style, textStyle }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const customTextStyle = [{
            fontSize: normalize(size / 3),
            fontWeight: 800,
            color: base_ui_theme_colors_1.color.light
        }, style];
    return (react_1.default.createElement(exports.BaseAvatarIcon, { color: base_ui_theme_colors_1.color.dark_tertiary, border: border, size: size, style: style },
        react_1.default.createElement(react_native_1.Text, { style: customTextStyle }, `+${num}`)));
};
exports.AdditionalPlayerIcon = AdditionalPlayerIcon;
const BaseAvatarIcon = ({ color, border, size = exports.DEFAULT_AVATAR_SIZE, style, children }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const customStyle = [{
            width: normalize(size),
            height: normalize(size),
            backgroundColor: color,
            borderColor: base_ui_theme_colors_1.color.dark,
            borderWidth: border ? normalize(3) : 0,
            borderRadius: normalize(size / 3),
            alignItems: 'center',
            justifyContent: 'center'
        }, style];
    return (react_1.default.createElement(react_native_1.View, { style: customStyle }, children));
};
exports.BaseAvatarIcon = BaseAvatarIcon;
//# sourceMappingURL=avatar.js.map